import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import axios from "axios";

// Firebase App (the core Firebase SDK) is always required and must be listed first
import * as firebase from "firebase/app";
// If you enabled Analytics in your project, add the Firebase SDK for Analytics
import "firebase/analytics";
// Add the Performance Monitoring library
import "firebase/performance";

const firebaseConfig = {
  apiKey: "AIzaSyDCe2x4JFMK4S8FQMVaT9L_sz4yRxBvkIU",
  authDomain: "covidsl-info.firebaseapp.com",
  databaseURL: "https://covidsl-info.firebaseio.com",
  projectId: "covidsl-info",
  storageBucket: "covidsl-info.appspot.com",
  messagingSenderId: "200258123872",
  appId: "1:200258123872:web:8785fafbffc3cc0126ab05",
  measurementId: "G-257WNR43JC"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

firebase.analytics().logEvent('notification_received');
const perf = firebase.performance();

axios.interceptors.request.use(
  request => {
    // console.log(request);
    // Edit request config
    return request;
  },
  error => {
    console.log(error);
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => {
    // console.log(response);
    // Edit request config
    return response;
  },
  error => {
    console.log(error);
    return Promise.reject(error);
  }
);

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
